import { memo } from 'react';
import isEqual from 'react-fast-compare';

import { type GalleryItem } from './types';

export type GalleryViewBoxProps = {
  isVisible: boolean;
} & GalleryItem;

export const GalleryViewBox = memo(({ box, render, index, isVisible }: GalleryViewBoxProps) => {
  return (
    <div
      className="[&>*]:h-full"
      style={{
        height: box.height,
        left: box.left,
        position: 'absolute',
        width: box.width,
      }}
    >
      {render(index, isVisible)}
    </div>
  );
}, isEqual);

GalleryViewBox.displayName = 'GalleryViewBox';
